import {postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
export enum valdiationRule {
    Header = 0,
    ModRequired = 1,
    ModRestricted = 2,
    PcRequired = 3,
    PcRestricted = 4,
    DxRequired = 5,
    DxRestricted = 6,
    PdxRequired = 7,
    PdxRestricted = 8,
    MinUnits = 9,
    MaxUnits = 10,
    RenderingReferring = 11
};
export enum validationRuleFlag {
    required = "1",
    restricted = "0" 
};
export enum validationRuleType {
    procedureCode = "PC",
    modifer = "MOD",
    diagnosisCode = "DX",
    primaryDX = "PDX"
};
export enum ErrorReturnMessage {
    feesReturn = "Unable to get fee information.",
    noActiveFees = "No active fees found.",
    matchingCode = "The procedure code cannot be the same as the incoming procedure code.",
    duplicateValue1 = "Duplicate value entered.",
    duplicateValue2 = "Value cannot be the same in both required/restricted areas.",
    copyValidation = "Unable to Copy code validations"
}
export interface ICodeItem
{
    procedureCode: string,
    billCode?: string,
    codeClass?: string,
    codeType?: string,
    codeDescription: string,
    feeType: string,
    feeAmount?: number,
    allowedAmount?: number,
    feeStartDate: string,
    feeEndDate: string,
    providerName?: string,
    finClassName?: string,
    payerName?: string,
    serviceLocationName?: string,
    minUnitsDisabled: number,
    maxUnitsDisabled: number,
    providerDisabled: number 
};
export interface IFeeItem
{
    negotiatedId: number,
    procedureCode: string,
    feeStartDate: string,
    feeEndDate: string,
    providerName?: string,
    finClassName?: string,
    payerName?: string,
    serviceLocationName?: string
};
export interface IValidationItem 
{
    ruleId: number,
    ruleType: string,
    ruleFlag: string,
    ruleValue: string,
    bypassFlag: number
};
export interface IValidationCopyResponse 
{
    codeRecord: ICodeItem,
    ruleList: IValidationItem[]
};
export interface IValidationFeeResponse 
{
    feeRecords: IFeeItem[]
};
export interface INegotiatedIDList 
{
    negotiatedId: number
};
export interface INegotiatedIDRequest 
{
    negotiatedFeeList: INegotiatedIDList[]
};
export interface IValidationCopyRequest 
{
    ValidationList : IValidationItem[],
    NegotiatedFeeList : INegotiatedIDList[]
};
export interface IValidationCopyUpdateResponse {
    errorCode: number
    errorMessage: string 
}
export async function FeesRetrieve(payload: INegotiatedIDRequest): Promise<IResultAndError<IValidationFeeResponse>>{
    return postObjectWithApiError("api/Procedures/ValidationCopy/FeesRetrieve", payload);
};
export async function CodeValidationCopy(payload: IValidationCopyRequest): Promise<IResultAndError<IValidationCopyUpdateResponse>>{
    return postObjectWithApiError("api/Procedures/ValidationCopy/CodeValidationCopy", payload);
};